import React from 'react'
import TextNumberBox from '../textNumberBox'
import { HeaderWrap, TextNumberBoxHeading, TextNumberBoxWrapper } from './style'
import CardBlock from '../cardBlock'

const HeaderRow = ({ data }) => {
  const dataFormat = [
    { id: 'CampaignMagnetScore' },
    { id: 'Engagement' },
    { id: 'NetVibe' },
    { id: 'EarnedOrganicReach' },
    { id: 'PaidReach' },
    { id: 'BrandAssociation' },
  ]

  return (
    <HeaderWrap
      className='campaignTriggersRow headerWrap pptSectionWrap'
      id='campaign-header-row'
      direction='row'
      spacing={2}
    >
      <TextNumberBoxHeading className='titleForPPT'>Average</TextNumberBoxHeading>
      <TextNumberBoxWrapper>
        {dataFormat?.map((item, i) => {
          // const val = `${parseInt(data[item.id]).toLocaleString('en-US')}${item.postFix}`
          const val = parseInt(data[item.id])
          return <>
            <CardBlock
              id={item.id}
              value={val}
              type='block'
            />
            {/* <TextNumberBox
              src={item.src}
              key={item.id}
              primary={val}
              secondary={item.label}
            /> */}
            {i === 2 && <div className='breaker'></div>}
          </>
        })}
      </TextNumberBoxWrapper>
    </HeaderWrap>
  )
}

export default HeaderRow
